// extracted by mini-css-extract-plugin
export default {"select":"LangSwitcher_select__5DxNs","icon":"LangSwitcher_icon__FnSyt"};